import React from "react";
import classNames from './PrivacyPolicy.module.css'
import { ProductName } from "../../Styles/ProductName";

export const PrivacyPolicy = () => (
	<main className={classNames.ContentPageContainerElement}>
		<h1><ProductName/> — Privacy Policy</h1>
		
		
		<p>The <ProductName/> browser extension collects data exclusively for your use.
			The extension sends <b>no</b> data to us. None. Nil. Squat. Zero. Zilch. Zip.</p>
	
		<p>Since we do not collect any of your data, we do not share your data with anyone. Nobody.
			We cannot share it because we do not have it.
		</p>
		
		<p>Why have a privacy policy that describes what we do with the data we collect if we do not collect any?
			Surveillance capitalists appear to have been unable to imagine that someone might ever make software
			for you, instead of to get data from you.
			So, we have to do the work to write a privacy policy for code that runs entirely on your computer and sends no data to us.
			At least we are having a good time doing it.
		</p>
		
		<p>Also, it gives us the opportunity to consider that, at some point,
			it might make sense for us to collect telemetry to make <ProductName/> work better for you.
			This is the point where the privacy policy would tell you that we reserve the right to notify that we are changing these terms terms at any time.
			That doesn't seem cool, though.
			If we have a good reason to start collecting data we will (imagine this!) <b>ask your permission first</b>.</p>
		
		<p>
			While we collect no data, you should know that when you record a browser session, the extension will generate one API request to CloudFlare to learn the publicly-facing IP address of your device as seen from outside your network. We record that IP address for you so that you can search to see if it appears in any network traffic. (Your actual device IP may be different from your publicly-facing IP if you access the Internet through a router that allows multiple devices to share a publicly-facing IP.)
		</p>

	</main>);
